import { render, staticRenderFns } from "./ViewBundleCourse.vue?vue&type=template&id=378cc948&scoped=true&"
import script from "./ViewBundleCourse.vue?vue&type=script&lang=js&"
export * from "./ViewBundleCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378cc948",
  null
  
)

export default component.exports